export const OVERVIEW_PATH = '/mailboxes';
export const CATEGORY_CATALOG_PATH = '/mailboxes/category-catalog';
export const MAILBOX_DETAIL_PATH = '/mailboxes/:id/:tab?';
export const MAILBOX_CATEGORY_DETAIL_PATH = '/mailboxes/:id/categories/:categoryId';
export const CATEGORY_CATALOG_DETAIL_PATH = '/mailboxes/category-catalog/:mailboxId/:categoryId';
